/**
 * Canonical dispatch-domain enums. Values match the wire format emitted by
 * `backend-tms/src/ai-routing/entities/driver-assignment.entity.ts` — the
 * `status` column is `varchar(20)` so any value change requires a data
 * backfill, not a Postgres `ALTER TYPE`.
 */

export enum AssignmentStatus {
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  REASSIGNED = 'reassigned',
}
